module.exports = __webpack_public_path__ + "static/media/regus-icon-font.5d11945d.woff2";